var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200.34 214.58",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.25 174.49q-34 18.51-67.94 37C18.13 220.27 0 209.41 0 191v-83.89V23A22.88 22.88 0 0123.7 0a24.24 24.24 0 0110.81 3.25l67.74 36.9zm85.47-46.55l-58.47 31.86v-105L162 72.71l25.7 14c8.16 4.45 12.61 11.33 12.62 20.61s-4.44 16.17-12.6 20.62z",
    fill: "#6381f3"
  })));
}
export default SvgLogo;